import {Button} from '@nlabs/gothamjs';

import ufatProjectsOfficeHero from '../../assets/ufat-projects-office-hero.png';
import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {Section} from '../../components/Section';
import {getProjectBySlug} from '../../data/projects';
import {navigate} from '../../lib/navigation';
import {buttonDarkPrimary, buttonOutlineDark, sectionActions} from '../../lib/styles';
import {Route} from '../../types/routes';

const getSlugFromRoute = (route: Route) => route.replace('/projects/', '');

export const ProjectDetail = ({route}: {route: Route}) => {
  const project = getProjectBySlug(getSlugFromRoute(route));

  if(!project) {
    return (
      <Page route={route}>
        <Section className="nx-section-project-detail" title="Project not found">
          <div className="grid max-w-[940px] gap-[22px]">
            <p className="m-0 text-[clamp(1.12rem,1.8vw,1.45rem)] leading-[1.72] text-[rgba(52,64,84,.88)]">That project is not available yet.</p>
            <Button className={buttonDarkPrimary} onClick={() => navigate('/projects')}>Back to Projects</Button>
          </div>
        </Section>
      </Page>
    );
  }

  return (
    <Page route={route}>
      <Hero
        actions={(
          <>
            <a className={buttonDarkPrimary} href={project.ctaUrl}> {project.ctaLabel}</a>
            <Button className={buttonOutlineDark} onClick={() => navigate('/projects')}>All Projects</Button>
          </>
        )}
        backgroundImage={ufatProjectsOfficeHero}
        copyTone="dark"
        imageLabel={`${project.title} project detail`}
        kicker={project.group}
        subtitle={project.body}
        title={project.title}
        tone="cyan"
    />
    <Section className="nx-section-project-detail" title={project.title}>
      <div className="grid max-w-[940px] gap-[22px]">
        <p className="mb-[-2px] mt-0 text-[.84rem] font-extrabold uppercase tracking-[.04em] text-[var(--nx-blue)]">{project.group} / {project.category}</p>
        <p className="m-0 text-[clamp(1.12rem,1.8vw,1.45rem)] leading-[1.72] text-[rgba(52,64,84,.88)]">{project.detail}</p>
        <div className={sectionActions}>
          <a className={buttonDarkPrimary} href={project.ctaUrl}>{project.ctaLabel}</a>
          <Button className={buttonOutlineDark} onClick={() => navigate('/projects')}>Back to Projects</Button>
        </div>
        </div>
      </Section>
    </Page>
  );
};
